var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { apiGetListConsultantPsSlidePage } from '../../../../actions/SearchConsultantActions';
import { wrapDispatch } from '../../../action';
import { useSlideSearchSlideViewParams } from '../../proffit_search/common/useSlideSearchSlideParams';
import { useSlideSearchSlideSlides } from '../../proffit_search/common/useSlideSearchSlideSlides';
import { useBoolState, useUnmountRef } from '../../useHook';
export const usePsSlideOne = (options) => {
    const { match, search } = options;
    const { params: { id }, } = match || {};
    const unmountRef = useUnmountRef();
    const dispatch = useDispatch();
    const { boolState: loading, changeFalse: changeLoadingFalse, changeTrue: changeLoadingTrue, } = useBoolState();
    const [rawSlides, setRawSlides] = useState(null);
    const { ids, viewParams } = useSlideSearchSlideViewParams({ id, search });
    /**
     * 取得した値を整形
     * @param list
     * @param metaIds
     * @returns {Object}
     */
    const formatSlides = useCallback((list, metaIds) => {
        const slides = {};
        metaIds.forEach((metaId) => {
            const slide = list.find((v) => v.slideSearchSlideUuid === metaId) || {};
            slides[metaId] = {
                id: metaId,
                result: !!slide,
                value: slide,
            };
        });
        return slides;
    }, []);
    /**
     * PSスライド 詳細ページ データ取得
     * @param slideIds
     */
    const loadSlides = useCallback((slideIds) => __awaiter(void 0, void 0, void 0, function* () {
        changeLoadingTrue();
        const { payload } = yield wrapDispatch(dispatch, apiGetListConsultantPsSlidePage({ ids: slideIds }));
        const formattedSlides = formatSlides(payload === null || payload === void 0 ? void 0 : payload.list, slideIds);
        if (unmountRef.current) {
            return;
        }
        setRawSlides(formattedSlides);
        changeLoadingFalse();
    }), [
        changeLoadingFalse,
        changeLoadingTrue,
        dispatch,
        formatSlides,
        setRawSlides,
        unmountRef,
    ]);
    useEffect(() => {
        loadSlides(ids);
    }, [ids, loadSlides]);
    const { defaultImageIndexMap, defaultSlideIndex, mainSlide, slides } = useSlideSearchSlideSlides({
        id,
        ids,
        rawSlides: rawSlides || {},
        viewParams,
    });
    return {
        defaultImageIndexMap,
        defaultSlideIndex,
        loading,
        mainSlide,
        rawSlides,
        slides,
    };
};
export default usePsSlideOne;
